<app-loader></app-loader>
<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>

    <a [routerLink]="['/touchscreen']" class="kiosk-brand d-flex align-items-center" aria-current="page">
      <img src="{{ coreConfig.app.appLogoImage }}" class="kiosk-logo" alt="logo">
      <div class="kiosk-brand-text">
        <div class="kiosk-title">{{ coreConfig.app.appRumahSakit }}</div>
        <div class="kiosk-subtitle">{{ coreConfig.app.appVendor }}</div>
      </div>
    </a>

  </div>

  <ul class="nav navbar-nav align-items-center ml-auto kiosk-controls">
    <!-- Settings Button -->
    <li class="nav-item">
      <a class="nav-link kiosk-settings-btn" (click)="openSettings(settingsModal)">
        <i class="fa fa-cog"></i>
        <span class="ml-50">Setting</span>
      </a>
    </li>
  </ul>
</div>

<!-- Settings Modal -->
<ng-template #settingsModal let-modal>
  <div class="kiosk-modal-header">
    <h5 class="kiosk-modal-title">Pengaturan</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="kiosk-modal-body">
    <div class="kiosk-setting-item">
      <div class="kiosk-setting-info">
        <span class="setting-title">Cetak DS</span>
        <span class="setting-desc">Cetak melalui Desktop Service</span>
      </div>
      <div class="custom-control custom-control-primary custom-switch">
        <input type="checkbox" class="custom-control-input" id="ds-switch"
          [(ngModel)]="isCetakDSKiosk" (change)="handleChange(isCetakDSKiosk)" />
        <label class="custom-control-label" for="ds-switch"></label>
      </div>
    </div>

    <div class="kiosk-setting-divider"></div>

    <div class="kiosk-setting-item">
      <div class="kiosk-setting-info">
        <span class="setting-title">Cetak SEP</span>
        <span class="setting-desc">Cetak SEP pada Kiosk</span>
      </div>
      <div class="custom-control custom-control-primary custom-switch">
        <input type="checkbox" class="custom-control-input" id="sep-switch"
          [(ngModel)]="isCetakSep" (change)="handleChange2(isCetakSep)" />
        <label class="custom-control-label" for="sep-switch"></label>
      </div>
    </div>

    <div class="kiosk-setting-divider"></div>

    <div class="kiosk-setting-item">
      <div class="kiosk-setting-info">
        <span class="setting-title">Fullscreen</span>
        <span class="setting-desc">{{ isFullscreen ? 'Keluar mode layar penuh' : 'Masuk mode layar penuh' }}</span>
      </div>
      <button class="btn btn-outline-primary kiosk-fullscreen-btn" (click)="isFullscreen ? closeFullscreen() : openFullscreen()">
        <i class="fa" [ngClass]="isFullscreen ? 'fa-compress' : 'fa-expand'"></i>
        {{ isFullscreen ? 'Keluar' : 'Masuk' }}
      </button>
    </div>
  </div>
</ng-template>
